export function pickHeartDxHrBpm(data) {
  const v = data?.heartdx?.hr ?? data?.results?.heartdx?.data?.hr ?? data?.hr; // legacy fallback if you used to store one
  const n = Number(v);
  return Number.isFinite(Math.round(n)) ? Math.round(n) : null;
}

// export function pickCppHrBpm(data) {
//   const v =
//     data?.results?.cpp?.data?.hr_bpm ??
//     data?.results?.cpp?.data?.hrBpm ??
//     data?.cpp_hr_bpm; // if you stored a flattened convenience field
//   const n = Number(v);
//   return Number.isFinite(Math.round(n)) ? Math.round(n) : null;
// }
